import { cn } from "@/lib/utils";

const config = {
  REAL: { bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-500", label: "Dato real" },
  ESTIMADO: { bg: "bg-blue-50", text: "text-blue-700", dot: "bg-blue-500", label: "Estimado" },
  MOCK: { bg: "bg-slate-100", text: "text-slate-600", dot: "bg-slate-400", label: "Mock" },
  SIMULADO: { bg: "bg-amber-50", text: "text-amber-700", dot: "bg-amber-500", label: "Simulado" },
  PENDIENTE: { bg: "bg-rose-50", text: "text-rose-700", dot: "bg-rose-500", label: "Pendiente" },
};

export default function LeyendaEstado({ estado, size = "sm" }) {
  const c = config[estado] || config.MOCK;

  if (size === "dot") {
    return (
      <span
        data-testid={`leyenda-dot-${estado}`}
        className={cn("inline-block w-2 h-2 rounded-full", c.dot)}
        title={c.label}
      />
    );
  }

  return (
    <span
      data-testid={`leyenda-${estado}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[10px] font-semibold",
        c.bg,
        c.text
      )}
    >
      <span className={cn("w-1.5 h-1.5 rounded-full", c.dot)} />
      {c.label}
    </span>
  );
}
